 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import HTML01_COVER from '@/components/html/01_cover'
 import HTML001_HTP from '@/components/html/001_htp'
 import HTML002_AUTHOR from '@/components/html/002_author'
 import HTML003_TP from '@/components/html/003_tp'
 import HTML004_CR from '@/components/html/004_cr'
 import HTML005_TOC from '@/components/html/005_toc'
 import HTML005_LIST from '@/components/html/005_list'
 import HTML006_DEDI from '@/components/html/006_dedi'
 import HTML007_ACKNOW from '@/components/html/007_acknow'
 import HTML008_PROLOGUE from '@/components/html/008_prologue'
 import HTML009_C1 from '@/components/html/009_c1'
 import HTML010_C2 from '@/components/html/010_c2'
 import HTML011_C3 from '@/components/html/011_c3'
 import HTML012_C4 from '@/components/html/012_c4'
 import HTML013_C5 from '@/components/html/013_c5'
 import HTML014_C6 from '@/components/html/014_c6'
 import HTML015_C7 from '@/components/html/015_c7'
 import HTML016_C8 from '@/components/html/016_c8'
 import HTML017_C9 from '@/components/html/017_c9'
 import HTML018_C10 from '@/components/html/018_c10'
 import HTML019_C11 from '@/components/html/019_c11'
 import HTML020_C12 from '@/components/html/020_c12'
 import HTML021_C13 from '@/components/html/021_c13'
 import HTML022_C14 from '@/components/html/022_c14'
 import HTML023_C15 from '@/components/html/023_c15'
 import HTML024_C16 from '@/components/html/024_c16'
 import HTML025_C17 from '@/components/html/025_c17'
 import HTML026_C18 from '@/components/html/026_c18'
 import HTML027_C19 from '@/components/html/027_c19'
 import HTML028_C20 from '@/components/html/028_c20'
 import HTML029_C21 from '@/components/html/029_c21'
 import HTML030_C22 from '@/components/html/030_c22'
 import HTML031_C23 from '@/components/html/031_c23'
 import HTML032_C24 from '@/components/html/032_c24'
 import HTML033_C25 from '@/components/html/033_c25'
 import HTML034_C26 from '@/components/html/034_c26'
 import HTML035_C27 from '@/components/html/035_c27'
 import HTML036_C28 from '@/components/html/036_c28'
 import HTML037_C29 from '@/components/html/037_c29'
 import HTML038_C30 from '@/components/html/038_c30'
 import HTML039_C31 from '@/components/html/039_c31'
 import HTML040_C32 from '@/components/html/040_c32'
 import HTML041_GLO from '@/components/html/041_glo'
 import HTML042_ENDNOTE from '@/components/html/042_endnote'
 import HTML043_P1 from '@/components/html/043_p1'
 import HTML044_P2 from '@/components/html/044_p2'
 import HTML045_P3 from '@/components/html/045_p3'
 import HTML046_P4 from '@/components/html/046_p4'
 import HTML047_P5 from '@/components/html/047_p5'
 import HTML048_P6 from '@/components/html/048_p6'
 import HTML049_P7 from '@/components/html/049_p7'
 import HTML050_P8 from '@/components/html/050_p8'
 import HTML051_P9 from '@/components/html/051_p9'
 import HTML052_P10 from '@/components/html/052_p10'
 import HTML053_P11 from '@/components/html/053_p11'
 import HTML054_P12 from '@/components/html/054_p12'
 import HTML055_P13 from '@/components/html/055_p13'
 import HTML056_P14 from '@/components/html/056_p14'
 import HTML057_P15 from '@/components/html/057_p15'
 import HTML058_P16 from '@/components/html/058_p16'
 import HTML059_P17 from '@/components/html/059_p17'
 import HTML060_P18 from '@/components/html/060_p18'
 import HTML061_P19 from '@/components/html/061_p19'
 import HTML062_ADVERT from '@/components/html/062_advert'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/html/01_cover",
 			"name" : "html/01_cover",
 			"component" : HTML01_COVER
 		},
 		{
 			"path" : "/html/001_htp",
 			"name" : "html/001_htp",
 			"component" : HTML001_HTP
 		},
 		{
 			"path" : "/html/002_author",
 			"name" : "html/002_author",
 			"component" : HTML002_AUTHOR
 		},
 		{
 			"path" : "/html/003_tp",
 			"name" : "html/003_tp",
 			"component" : HTML003_TP
 		},
 		{
 			"path" : "/html/004_cr",
 			"name" : "html/004_cr",
 			"component" : HTML004_CR
 		},
 		{
 			"path" : "/html/005_toc",
 			"name" : "html/005_toc",
 			"component" : HTML005_TOC
 		},
 		{
 			"path" : "/html/005_list",
 			"name" : "html/005_list",
 			"component" : HTML005_LIST
 		},
 		{
 			"path" : "/html/006_dedi",
 			"name" : "html/006_dedi",
 			"component" : HTML006_DEDI
 		},
 		{
 			"path" : "/html/007_acknow",
 			"name" : "html/007_acknow",
 			"component" : HTML007_ACKNOW
 		},
 		{
 			"path" : "/html/008_prologue",
 			"name" : "html/008_prologue",
 			"component" : HTML008_PROLOGUE
 		},
 		{
 			"path" : "/html/009_c1",
 			"name" : "html/009_c1",
 			"component" : HTML009_C1
 		},
 		{
 			"path" : "/html/010_c2",
 			"name" : "html/010_c2",
 			"component" : HTML010_C2
 		},
 		{
 			"path" : "/html/011_c3",
 			"name" : "html/011_c3",
 			"component" : HTML011_C3
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js